import { RankingGroupApiItem } from "@/entities/search-ranking/model/types"

// 랭킹 쿼리의 '계약' — 서버 프리페치(search/ranking/page.tsx)와 클라 훅(useRankingHospitals)이
// 같은 queryKey·같은 그룹 판정 로직을 쓰도록 한곳에 모은다. 키가 어긋나면 장애 대신
// 'SSR 효과 소멸 + 이중 fetch'로 조용히 새기 때문에 test/ssr-pre-guards.test.tsx 가 계약을 잠근다.

export const rankingQueryKeys = {
  groups: ["rankingGroups"] as const,
  hospitals: (hospitalRankingGroupId: number | "none", regionAll: boolean) =>
    ["rankingHospitals", hospitalRankingGroupId, regionAll] as const,
}

export const DEFAULT_RANKING_REGION_ID = 1
export const DEFAULT_RANKING_TREATMENT_ID = 1

type RankingParam = string | string[] | null | undefined

const firstParam = (value: RankingParam) => Array.isArray(value) ? value[0] : value

export const parseCategoryId = (value: string | null) => {
  if (!value) return undefined
  const id = Number(value.split(",")[0])
  return Number.isFinite(id) ? id : undefined
}

export const resolveRankingSelection = (
  regionValue: RankingParam,
  treatmentValue: RankingParam,
) => {
  const parsedRegionIds = (firstParam(regionValue) ?? "")
    .split(",")
    .map(Number)
    .filter((id) => Number.isFinite(id) && id > 0)
  const treatmentCategoryId = parseCategoryId(firstParam(treatmentValue) ?? null)

  return {
    regionIds: parsedRegionIds.length > 0 ? parsedRegionIds : [DEFAULT_RANKING_REGION_ID],
    treatmentCategoryId: treatmentCategoryId ?? DEFAULT_RANKING_TREATMENT_ID,
  }
}

export const findRankingGroupId = (
  rankingGroups: RankingGroupApiItem[] | undefined,
  regionCategoryId: number | undefined,
  treatmentCategoryId: number | undefined,
) => {
  if (rankingGroups == null || treatmentCategoryId == null) {
    return undefined
  }

  return rankingGroups.find(
    (group) =>
      (regionCategoryId == null || group.regionCategoryId === regionCategoryId) &&
      group.treatmentCategoryId === treatmentCategoryId,
  )?.id
}
